import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MiscService } from 'app/services/misc.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FooterComponent implements OnInit {
  links: object[];
  linksEN: object[];
  FinnishSelected = false;

  constructor(
    private miscService: MiscService
  ) {
    this.FinnishSelected = this.miscService.getLanguage();
    this.miscService.languageChange.subscribe((value) => {
      this.FinnishSelected = value;
    });

    this.links = [
      { title: 'Työ- ja elinkeinoministeriö ', link: 'http://www.tem.fi' },
      { title: 'Ympäristöministeriö', link: 'http://www.ym.fi/FI-FI' },
      { title: 'Energiavirasto', link: 'http://www.energiavirasto.fi' },
      { title: 'Elinkeinoelämän keskusliitto EK', link: 'http://www.ek.fi' },
      { title: 'Autoalan Keskusliitto ry ', link: 'http://www.akl.fi' },
      { title: 'Elintarviketeollisuusliitto ry ', link: 'http://www.etl.fi' },
      { title: 'Energiateollisuus ry', link: 'http://www.energia.fi' },
      { title: 'Kaupan Liitto', link: 'http://www.kauppa.fi' },
      { title: 'Kemianteollisuus ry', link: 'http://www.kemianteollisuus.fi' },
      { title: 'Matkailu- ja Ravintolapalvelut MaRa ry', link: 'http://www.mara.fi' },
      { title: 'Metsäteollisuus ry', link: 'http://www.metsateollisuus.fi' },
      { title: 'Muoviteollisuus ry', link: 'https://www.plastics.fi' },
      { title: 'Teknologiateollisuus ry', link: 'http://www.teknologiateollisuus.fi' },
      { title: 'RAKLI ry', link: 'http://www.rakli.fi' },
      { title: 'Kuntaliitto', link: 'http://www.kuntaliitto.fi' },
      { title: 'Öljy- ja biopolttoaineala ry', link: 'http://www.oil.fi' },
      { title: 'Öljyalan Palvelukeskus Oy', link: 'http://www.oil.fi' },
      { title: 'Suomen Bensiinikauppiaitten ja Liikennepalvelualojen Liitto SBL ry', link: 'http://www.bensiinikauppiaat.fi' },
      { title: 'Motiva', link: 'http://www.motiva.fi' }
    ];
    this.linksEN = [
      { title: 'The Ministry of Economic Affairs and Employment', link: 'http://tem.fi/en/frontpage' },
      { title: 'Ministry of the Environment', link: 'http://www.ym.fi/en-US' },
      { title: 'Energy Authority', link: 'http://www.energiavirasto.fi/en/web/energy-authority' },
      { title: 'Confederation of Finnish Industries EK', link: 'http://ek.fi/en/' },
      { title: 'Finnish Central Organisation for Motor Trades and Repairs', link: 'http://www.akl.fi/in_english/about_us' },
      { title: 'The Finnish Food and Drinks Industries’ Federation ETL', link: 'http://www.etl.fi/en/index.html' },
      { title: 'Finnish Energy Industries', link: 'https://energia.fi/EN' },
      { title: 'The Federation of Finnish Commerce', link: 'http://kauppa.fi/eng' },
      { title: 'Chemical Industry Federation of Finland', link: 'http://www.kemianteollisuus.fi/en/' },
      { title: 'Finnish Hospitality Association MaRa', link: 'http://www.mara.fi/en' },
      { title: 'Finnish Forest Industries', link: 'http://www.forestindustries.fi/' },
      { title: 'Finnish Plastics Industries Federation', link: 'http://www.plastics.fi/eng/' },
      { title: 'The Federation of Finnish Technology Industries', link: 'http://www.teknologiateollisuus.fi/en' },
      { title: 'RAKLI The Finnish Association Building Owners and Construction Clients', link: 'http://www.rakli.fi/en/' },
      { title: 'The Association of Finnish Local and Regional Authorities', link: 'https://www.localfinland.fi/' },
      { title: 'Finnish Petroleum and Biofuels Association', link: 'http://www.oil.fi/en' },
      { title: 'Oil Industry Service Centre Ltd', link: 'http://www.oil.fi/en' },
      { title: 'Finnish Petrol and Traffic Service Retailers Organisation SBL', link: 'http://www.bensiinikauppiaat.fi/' },
      { title: 'Motiva', link: 'http://www.motiva.fi/en' }
    ];
  }

  ngOnInit() {}

}



// WEBPACK FOOTER //
// /Users/ilu/projektit/ets-tuloksia/src/app/footer/footer.component.ts